// eslint-disable-next-line import/no-extraneous-dependencies
import { bsc as wagmiBsc, bscTestnet, Chain, holesky } from '@wagmi/core/chains';

import { IS_PRODUCTION } from '../env';

import { cratD2CMainnet, cratD2Ctestnet } from './custom-chains';

// Default chain of bsc is outdated in wagmi
const bsc = {
  ...wagmiBsc,
  rpcUrls: {
    default: { http: ['https://bsc-rpc.publicnode.com/'] },
  },
} as const;

// NOTE: default chain always first
const SUPPORTED_CHAINS_MAINNET = [bsc, cratD2CMainnet] as const;
const SUPPORTED_CHAINS_TESTNET = [bscTestnet, cratD2Ctestnet, holesky] as const;

export const CHAINS: readonly [Chain, ...Chain[]] = IS_PRODUCTION ? SUPPORTED_CHAINS_MAINNET : SUPPORTED_CHAINS_TESTNET;

export const rpcUrlsByChain = {
  [bsc.id]: [
    'https://bsc-rpc.publicnode.com/',
    'https://bsc-dataseed1.binance.org/',
    'https://bsc-dataseed2.binance.org/',
    'https://bsc-dataseed3.binance.org/',
  ],
  [cratD2CMainnet.id]: [
    'https://node2.cratd2csmartchain.io',
    'https://node1.cratd2csmartchain.io',
    'https://node3.cratd2csmartchain.io',
  ],
  [bscTestnet.id]: ['https://bsc-testnet-rpc.publicnode.com', 'https://data-seed-prebsc-1-s1.binance.org:8545/'],
  [cratD2Ctestnet.id]: [
    'https://cratd2c-testnet-node1.cratd2csmartchain.io',
    'https://cratd2c-testnet-node1.cratd2csmartchain.io',
  ],
  [holesky.id]: ['https://ethereum-holesky-rpc.publicnode.com'],
} as Record<number, string[]>;

export const defaultChain = CHAINS[0];
export const cratChain = IS_PRODUCTION ? cratD2CMainnet : holesky;

export const cratChainNativeToken = cratChain.nativeCurrency;
